import SiderLayout from "../../layouts/SiderLayout";
import { InstitutionSlider } from "../../pages/Institutions/InstitutionSider/InstitutionSlider";
import React from "react";
import routes from "../routes";
import { generateChildren } from "./RouterGenerator";

let childrenNormal = generateChildren([
  routes.institutions().detailUsers,
  routes.institutions().detail,
  routes.institutions().newUserInstitution(),
  routes.institutions().detailUser(),
  routes.institutions().addresses,
  routes.institutions().locations,
  routes.institutions().responsables,
]);

export const institutionRouter = [
  {
    path: routes.institutions().path,
    handle: {
      crumb: e => routes.institutions().ressourceCrumb(e),
    },
    element: (
      <SiderLayout maxWidth={1200}>
        <InstitutionSlider />
      </SiderLayout>
    ),
    children: [
      {
        path: routes.institutions().detail.path,
        handle: {
          crumb: e => routes.institutions().crumb(e),
        },
        children: childrenNormal,
      },
    ],
  },
];
